import React from 'react';
import { InformationType } from '../../../types/information';

interface LoginInfoProps {
  title: string;
  informations: InformationType[];
}

const LoginInfo = ({ title, informations }: LoginInfoProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="loginInfo" className="pb-4">
        <h6>{title}</h6>
        <ul>
          {informations.map((information) => (
            <li key={information.id}>{information.message}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default LoginInfo;
